<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName"
    descriptionDeleted="Se eliminarán también los spots y autos del usuario. Está seguro que quiere continuar?"
    labelModalConfirm="Si" labelModalCancel="No" removeText="Eliminar Usuario" parentStoreName="Users_scroll"
    :canUpdateDelete="false" :canRefundCode="true" :submit="submit" :sendCode="sendCode" :status="status" :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '/admin/users_scroll'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver tag="div" ref="validator" v-slot="{ }">
      <v-row justify="center" no-gutters>
        <v-col cols="8">
          <v-row no-gutters class="mt-4">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="name" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field :error-messages="errors" v-model="data.name" label="Nombre" solo class="input-base"
                  hide-details="auto" disabled></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="last_name" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Apellidos</div>
                <v-text-field :error-messages="errors" v-model="data.last_name" label="Apellido" solo
                  hide-details="auto" class="input-base" disabled></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="email" rules="required|email" v-slot="{ errors }">
                <div class="label-base pb-1">Email</div>
                <v-text-field :error-messages="errors" v-model="data.email" label="Email" solo hide-details="auto"
                  maxlength="50" :rules="[v => v.length <= 49 || 'Email máximo de 50 caracteres']" class="input-base"
                  disabled></v-text-field>
              </ValidationProvider>
            </v-col>

<!--            <v-col class="py-0 px-2">-->
<!--              <ValidationProvider ref="code_verification" :rules="{ required: !data.id, min: 4 }" v-slot="{ errors }">-->
<!--                <div class="label-base pb-1">Codigo de verificación</div>-->
<!--                <v-text-field :error-messages="errors" v-model="data.code" label="Ingrese su código de verificación"-->
<!--                  solo hide-details="auto" class="input-base"></v-text-field>-->
<!--              </ValidationProvider>-->
<!--            </v-col>-->


          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="code_validation_email" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Total de monedas</div>
                <v-text-field :error-messages="errors" v-model="data.total_coins" disabled
                  label="Ingrese su código de verificación" solo hide-details="auto" class="input-base"
                  readonly></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="coins" rules="required|integer|numberpositivo" v-slot="{ errors }">
                <div class="label-base pb-1">Monedas a cargar</div>
                <v-text-field :error-messages="errors" v-model="data.coins_to_add" label="Ingrese monedas a cargar"
                  type="number" min="1" solo hide-details="auto" class="input-base custom-number">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.coins_to_add++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.coins_to_add = Math.max(0, data.coins_to_add - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="coins" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Comentarios</div>
                <v-textarea v-model="data.comments" :error-messages="errors" label="Comentario" auto-grow rows="8" solo
                  hide-details="auto" class="input-base" />
              </ValidationProvider>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/UploadProfile";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Phone from "@/components/Form/Phone";
import PasswordInput from "@/components/Form/PasswordInput";
import Swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver, Phone, PasswordInput },

  data() {
    return {
      storeName: "Users_scroll",
      title: this.$route.params.id ? "Cargar monedas" : "Cargar monedas",
      labelSubmit: "Cargar",
      filteredAttributes: ["profile_picture"],
      show1: false,
      profile_picture: "",
      user_document: {
        user_document_back: null,
        user_document_front: null,
      },
      data: {
        id: "",
        user_enterprise_id: "",
        name: "",
        last_name: "",
        email: "",
        code_validation_email: "",
        total_coins: 0,
        coins_to_add: 0,
        comments: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Users.status,
      customerrors: (state) => state.Users_scroll.customerrors,
      currentUser: (state) => state.Authenticate.user,
      iva_conditions: (state) => state.Users.iva_conditions,
    }),
  },
  watch: {
    customerrors(val) {
      if (val.message && val.code === 'ERROR') {
        Swal(
          "Error",
          val.message,
          "error",
          {
            buttons: false,
            timer: 3000,
          }
        );
      }
    },
  },
  methods: {
    blockE(e) {
      const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
      const currentValue = e.target.value;
      if (allowedKeys.includes(e.key)) return;

      if (e.key === "." && !currentValue.includes(".")) return;
      if ((e.key < "0" || e.key > "9") && e.key !== ".") {
        e.preventDefault();
      }
    },
    increaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      this.data.commission_percentage = (val + 1).toString();
    },

    decreaseValue() {
      const val = parseFloat(this.data.commission_percentage || 0);
      if (val > 0) this.data.commission_percentage = (val - 1).toString();
    },
    onCreate(data) {
      if (data.user_document) {
        this.user_document = {
          ...this.user_document,
          ...data.user_document,
        };
      }
    },
    onSelectedPicture(file) {
      console.log('🐱 file: ---- 🐱 \n', file);
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.profile_picture = fr.result;
      };
      fr.onerror = function () {
        self.profile_picture = "";
      };
      fr.readAsDataURL(this.data.profile_picture);
    },
    async sendCode() {
      const self = this;
      let route_send_code = "/sent_code_email"
      self.$store
        .dispatch(this.storeName + route_send_code, { email: self.currentUser.email })
        .then(() => {
          // self.goBack();
          Swal(
            "Envio de codigo de verificación",
            "Exitosamente",
            "success",
            {
              buttons: false,
              timer: 3000,
            }
          );
        });
    },
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        return (
          "/admin/" +
          this.parentStoreName.toLowerCase() +
          "/" +
          this.$route.params[this.parentUrlKey] +
          "/" +
          this.storeName.toLowerCase()
        );
      } else {
        return "/admin/" + (this.parentStoreUrl || this.storeName.toLowerCase());
      }
    },
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let route_set_coins = "/set_coins"
        console.log("data to submit:", { ...self.data, user_enterprise_id: self.currentUser.id });

        self.$store
          .dispatch(this.storeName + route_set_coins, { ...self.data, user_enterprise_id: self.currentUser.id })
          .then(function () {
            self.$router.push(self.buildRootUrl());
          })
          .catch(function (response) {
            Swal(
              "Error",
              response.message,
              "error",
              {
                buttons: false,
                timer: 3000,
              }
            );
          });
      }
    },
  },
};
</script>
